<template>
    <div>

        <v-dialog v-if="selectedResult != undefined" v-model="showViewDialog" width="600px" persistent scrollable
            style="max-width:600px;">
            <v-card style="margin-top:0px; border-radius:5px;">
                <v-card-title class="pt-2 blue darken-4">
                    <v-icon @click="closeDetail()" white
                        style="float:right;  margin-right:15px; color: white">clear</v-icon>
                    <span style="color: white; margin-top:10px;" class="ma-3 "><strong>{{ fileSelected }}</strong></span>
                </v-card-title>
                <v-card-text class="pt-4">
                    <div>
                        <table
                            :style="' width:100%; border:3px solid ' + getColorReader(selectedResult) + '; border-radius: 4px;'">
                            <tr>
                                <td class="pa-1" colspan="2">
                                    <span @click="starToggle(selectedResult)" class="ml-2">
                                        <v-icon small v-if="selectedResult.starred" color="orange">star</v-icon>
                                        <v-icon small v-else>star_outline</v-icon>
                                    </span>
                                    <strong class="pl-2">{{ selectedResult.id }}</strong>
                                    <small class="pl-2" style="float: right;"> {{ selectedResult.tmsLastUpdate }}</small>
                                </td>
                            </tr>
                            <tr>
                                <td class="pa-1"><small class="ml-2">Val. time: <strong>{{ selectedResult.valTime
                                }}</strong></small>
                                </td>
                                <td nowrap align="right">
                                    <small class="pl-2 ">
                                        {{ selectedResult.lastFile }}
                                    </small>
                                </td>
                            </tr>
                            <tr class="blue darken-2 white--text">
                                <td class="pa-1" colspan="2" align="center">
                                    Letture:<strong class="pl-2 ">{{ numRows }}</strong>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div>
                        <v-textarea height="340px" v-model="fileContent" outline></v-textarea>
                    </div>
                </v-card-text>
                <v-card-actions class="ma-4">
                    <v-layout class="mt-4">
                        <v-layout align-center row justify-center>
                            <v-btn round primary @click="closeDetail()">Chiudi</v-btn>

                        </v-layout>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-toolbar app color="black" dark>
            <v-toolbar-title data-cy="titleBtn">
                <img class="menuLogo ml-0" src="../assets/images/logo_icron_2.0_bianco.png" style="height: 40px"
                    @click="gotoHome()" />
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-layout v-if="isDesktopMode()" align-start row justify-center class="blue darken-2 p-0 m-0"
                style="border-radius: 10px 10px 10px 10px"><span class="white--text"><strong>ICRON Devices</strong></span>
            </v-layout>
            <span v-if="isMobileMode()">
                <v-icon v-if="!compatta" @click="compatta = !compatta">compress</v-icon>
                <v-icon v-else @click="compatta = !compatta">expand</v-icon>
            </span>
            <v-spacer></v-spacer>
            <v-icon v-if="!starred" @click="showStarred()">star</v-icon>
            <v-icon v-else color="yellow" @click="showStarred()">star</v-icon>
        </v-toolbar>

        <v-layout align-start row wrap justify-center class="pa-2 black--text grey lighten-4 ">
            <v-flex v-if="isMobileMode()" flex xs12 sm12 md12 lg12
                class="blue darken-2 white--text title font-weight-black pa-1">
                <v-layout align-start row justify-center class="blue darken-2 p-0 m-0"
                    style="border-radius: 10px 10px 10px 10px"><span class="white--text"><strong>ICRON
                            Devices</strong></span>
                </v-layout>
            </v-flex>

            <v-flex v-if="isDesktopMode()" flex xs12 sm12 md12 lg12 class="black--text title mt-3 ">
                <v-data-table :items="itemsF" hide-actions style="" class="mb-5">
                    <template slot="headers" slot-scope="props">
                        <tr class="" style="background-color: #f5f5f5 !important; height:20px">
                            <th></th>
                            <th><v-icon class="ml-2" @click="orderBy('id')" small>swap_vert</v-icon>Nome</th>
                            <th><v-icon class="ml-2" @click="orderBy('lastFile')" small>swap_vert</v-icon>Ultimo file</th>
                            <th><v-icon class="ml-2" @click="orderBy('valTime')" small>swap_vert</v-icon>Val time</th>
                            <th><v-icon class="ml-2" @click="orderBy('tmsLastUpdate')" small>swap_vert</v-icon>Ultima
                                trasmissione</th>
                            <th><v-icon class="ml-2" @click="orderBy('lastSyncExpression')" small>swap_vert</v-icon>Delta
                                time</th>
                            <th><v-icon class="ml-2" @click="orderBy('firmwareVersion')" small>swap_vert</v-icon>Firmware
                                version</th>
                            <th><v-icon class="ml-2" @click="orderBy('owner')" small>swap_vert</v-icon>Timer</th>
                        </tr>
                    </template>
                    <template slot="items" slot-scope="props" class="scroll-y" style="height: 600px">
                        <tr style="height:0px">
                        </tr>
                        <tr style="height:20px" :class="line_classes(props.item)">
                            <td align="center" width="10px" @click="starToggle(props.item)">
                                <v-icon small v-if="props.item.starred" color="orange">star</v-icon>
                                <v-icon small v-else>star_outline</v-icon>

                            </td>
                            <td nowrap align="left"
                                :style="'border-left: solid 15px ' + getColorReader(props.item) + '!important;'">
                                <span>{{ props.item.id }}</span>
                            </td>

                            <td nowrap align="left" @click="viewFile(props.item)">
                                {{ props.item.lastFile }}
                            </td>
                            <td nowrap align="center" @click="viewFile(props.item)">
                                <strong>{{ props.item.valTime }}</strong>
                            </td>
                            <td align="center" nowrap>
                                {{ props.item.tmsLastUpdate }}
                            </td>
                            <td align="center" nowrap>
                                {{ props.item.lastSyncExpression }}
                            </td>
                            <td align="center" nowrap>
                                {{ props.item.tipo }} - {{ props.item.firmwareVersion }}
                            </td>
                            <td align="center" nowrap>
                                {{ props.item.owner }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>



            <v-flex v-else flex xs12 sm12 md12 lg12 class="black--text title mt-3 ">
                <table style="width: 100%;">
                    <tr v-for="item in itemsF" :key="item.id">
                        <td @click="viewFile(item)" class="pa-0">
                            <table
                                :style="' width:100%; border:3px solid ' + getColorReader(item) + '; border-radius: 4px;'">
                                <tr>
                                    <td class="pa-1" colspan="2">
                                        <v-icon v-if="item.starred" color="orange">star</v-icon>
                                        <v-icon v-else>star_outline</v-icon>
                                        <strong class="pl-2">{{ item.id }}</strong>
                                        <small class="pl-1" style="float: right;"> {{ item.tmsLastUpdate }}</small>
                                    </td>
                                </tr>
                                <tr v-if="!compatta">
                                    <td class="pa-1"><small class="ml-2">Val. time: <strong>{{ item.valTime
                                    }}</strong></small>
                                    </td>
                                    <td nowrap align="right">
                                        <small class="pl-2 ">
                                            {{ item.lastFile }}
                                        </small>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </v-flex>


        </v-layout>

        <v-footer fixed class="p-0 grey darken-2" style="height: 30px;">
            <v-layout align-start row wrap justify-center style="width:100%; ">
                <v-flex flex xs12 sm12 md12 lg12 class="white pa-2">
                    <v-text-field class="white red--text pa-0" style="width:100%;" v-model="searchText"
                        label="Cerca nome o timer" outline clearable append-icon="search"
                        @input="changedSearch"></v-text-field>
                </v-flex>
            </v-layout>
        </v-footer>

    </div>
</template>


<script>
import dayjs from 'dayjs';
import helper from '../helper';


export default {
    components: {
    },
    name: 'Reader',

    data() {
        return {

            myInterval: undefined,
            items: [],
            itemsF: [],

            searchText: '',
            direction: false,
            orderByField: 'tmsLastUpdate',
            showViewDialog: false,
            fileSelected: undefined,
            fileContent: '',

            compatta: true,

            numRows: 0,

            selectedResult: undefined,

            starred: false,

            mapStars: {},



        };
    },

    mounted() {
        //this.reportId = this.$route.params.reportId;

        this.mapStars = helper.ls.get('DEVICESTARS');
        if (this.mapStars == undefined) {
            this.mapStars = {};
            helper.ls.set('DEVICESTARS', this.mapStars);
        }

        clearInterval(this.myInterval);
        this.myInterval = setInterval(this.refresh, 10000, this);
        this.loadReport()
    },


    beforeDestroy() {
        clearInterval(this.myInterval);
    },

    methods: {

        refresh: function (self) {
            self.loadReport();
        },

        starToggle(item) {
            console.log("Eccomi")
            if (this.mapStars[item.id] !== undefined) {
                this.mapStars[item.id] = !this.mapStars[item.id];
            } else {
                this.mapStars[item.id] = true;
            }
            helper.ls.set('DEVICESTARS', this.mapStars);
            item.starred = !item.starred

            this.itemsF = this.filteredList();
        },

        showStarred() {
            this.starred = !this.starred
            this.itemsF = this.filteredList();
        },



        loadReport() {

            const _url = "https://www.icron.it/IcronLiveServices/services/getLettori?sysid=&data=";
            this.getCall(_url).then((response) => {

                console.log(response)
                this.items = response.elencoLettori;

                this.items.forEach(it => {
                    it.starred = this.mapStars[it.id] != undefined && this.mapStars[it.id] == true
                })

                this.itemsF = this.filteredList();
            });
            if (this.selectedResult !== undefined) {
                this.viewFile(this.selectedResult)
            }
        },

        viewFile(item) {
            this.fileContent = "";
            this.numRows = 0;
            this.selectedResult = item;

            this.showViewDialog = true

            //https://www.icron.it/services/live/files/file-SPEED106-263.tags

            const _url = "https://www.icron.it/services/live/files/" + item.lastFile;
            this.getRemoteService(_url).then((response) => {
                //console.log(response)
                this.fileSelected = item.lastFile

                var lines = response.split("\n");
                var result = "";

                for (var i = 0; i < lines.length; i++)
                    result = lines[i] + "\n" + result;

                this.fileContent = result

                this.numRows = lines.length - 1

            }).catch(e => {
                this.fileContent = "File vuoto o non trovato"
            });
        },

        getColorReader(item) {
            const now = dayjs(new Date()).format('YYYY-MM-DD-HH:mm:ss');
            var duration = this.diffSeconds(now, item.tmsLastUpdate)
            //            console.log(duration)

            if (duration <= 180) return "green";
            else if (duration > 180 && duration < 3600) return "orange"

            return "red"

        },

        closeDetail() {
            this.selectedResult = undefined;
            this.showViewDialog = false;
        },

        line_classes(reader) {
           /* if (reader == 'SCONOSCIUTO') return " red darken-2  "
            let color = this.coloriSplit[name]
            if (color != undefined) return color + " lighten-3";
            */return ""
        },

        filteredList() {
            var listaSearch = this.items;
            if (this.searchText !== '' && this.searchText != null) {
                listaSearch = this.items.filter((p) => {
                    let res =
                        p != null &&
                        p.id != null &&
                        p.id.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;
                    let res1 =
                        p != null &&
                        p.squadra != null &&
                        p.squadra.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;

                    let res2 =
                        p != null &&
                        p.owner != null &&
                        p.owner == this.searchText;

                    let resTot = res || res1 || res2;
                    return resTot;
                });
            }

            if (this.starred) {
                listaSearch = listaSearch.filter(p => {
                    return p.starred == true;
                })
            }

            console.log("Applica filtro")


            if (this.orderByField !== null) {
                listaSearch.sort(this.simpleCompare);
            }
            return listaSearch;
        },


        orderBy(field) {
            if (this.orderByField === field) {
                this.direction = !this.direction;
            } else {
                this.direction = true;
                this.orderByField = field;
            }
            this.itemsF = this.filteredList();
        },



        simpleCompare(a, b) {
            return this.compareField(a, b)
        },

        compareField(a, b, fieldName = null) {

            if (fieldName == null) fieldName = this.orderByField;

            const molti = this.direction ? 1 : -1;

            let valoreA = a[fieldName];
            let valoreB = b[fieldName];

            let filtroTok = fieldName.split(".")
            if (filtroTok.length == 2) {
                valoreA = a[filtroTok[0]][filtroTok[1]];
                valoreB = b[filtroTok[0]][filtroTok[1]];
            }


            if (valoreA === undefined && valoreB == undefined) return 0;
            else if (valoreA === undefined) {
                return -1 * molti;
            } else if (valoreB === undefined) {
                return 1 * molti;
            }

            if (!isNaN(valoreA) && !isNaN(valoreB)) {
                valoreA = parseFloat(valoreA);
                valoreB = parseFloat(valoreB);
            }

            if (valoreA < valoreB) {
                return -1 * molti;;
            }
            if (valoreA > valoreB) {
                return 1 * molti;;
            }
            return 0;
        },



        changedSearch(event) {
            this.searchText = event;
            this.itemsF = this.filteredList();
        },


    }
}
</script>

